import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';
import { checkExperiment } from '../../../../utils/isAbExperiment';

const IDeveloperTagType = 'advanced-developer-type';

export interface IDeveloperTag {
  type: 'advanced-developer-type';
  value: boolean;
}

const isDeveloperTag = (tag: TTag): tag is IDeveloperTag => tag.type === IDeveloperTagType;

export const developerTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData, currentLocation, experiments) => {
    const value = jsonQuery.from_developer && jsonQuery.from_developer.value;
    const isFromDeveloperExperiment = checkExperiment(experiments, 'newbuilding-serp-from-developer');

    if (value !== undefined && !(isFromDeveloperExperiment && value)) {
      return ensureSingleTagExists(tags, isDeveloperTag, () => ({ type: IDeveloperTagType, value }));
    } else {
      return ensureTagNotExists(tags, isDeveloperTag);
    }
  },
};
